import BusinessHero from "../Components/Bhero";
import BStory from "../Components/Bstory";
import BPortfolio from "../Components/Bp";
import ManufacturingExcellence from "../Components/Me";
import ProductsIndustries from "../Components/Productindustries";
import ImpactStats from "../Components/Impact";
import MilestonesTimeline from "../Components/Timeline";



const Gallerypage = () => {
  return (
    <>
      <section id="BusinessHero">
        <BusinessHero />
      </section>

      <section id="BStory">
        <BStory />
      </section>

      <section id="BPortfolio">
        <BPortfolio />
      </section>

      <section id="ManufacturingExcellence">
        <ManufacturingExcellence />
      </section>

       <section id="ProductsIndustries">
        <ProductsIndustries />
      </section>

      <section id="ImpactStats">
        <ImpactStats />
      </section>

      <section id="MilestonesTimeline">
        <MilestonesTimeline />
      </section>



    </>
  );
};

export default Gallerypage;
